// This enumerates the types of losses and returns the options (label, color...)
// for a type of loss no matter if it is enabled or disabled.
const TYPES_OF_LOSSES = [
    {
        label: 'Availability',
        value: 'availability',
        color: 'primary'
    },
    {
        label: 'Performance',
        value: 'performance',
        color: 'dark-yellow'
    },
    {
        label: 'Planned shutdown',
        value: 'shutdown',
        color: 'grey-7'
    }
];

/**
 * Return the options (label, color...) for a type of loss
 * @param {Object} value
 */
function getLossOptions(value) {
    const options = TYPES_OF_LOSSES.find(item => item.value === value);
    if (options) {
        return options;
    }
    return {
        color: 'grey',
        label: '-',
        value: undefined
    };
}

export { TYPES_OF_LOSSES, getLossOptions };
